import GridContainer from "@/components/common/GridContainer";
import styled from "styled-components";
import {getCssSizeValue, getHtmlFromRedactorField, getPaddingsClassFromData, isStringEmpty} from "@/utils/utils";
import Image, {formatImageCMSData} from "@/components/common/Image";
import LinkButton from "@/components/common/Buttons/LinkButton";
import {getButtonLinkData} from "@/components/common/Buttons/Button";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Row = styled(GridContainer)`
    &.second {
        margin-top: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        &.second {
            margin-top: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
        }
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        &.second {
            margin-top: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)};
        }
	}
`

const Header = styled.div`
`

const ImageWrapper = styled.div`
	margin-top: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
    display: flex;
    width: 100%;
    align-items: center;

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
    	margin-top: unset;
	}
`

const StyledImage = styled(Image)`
    height: auto;
    aspect-ratio: ${({$aspectRatio}) => $aspectRatio || 1};
`

export default function HeadingGraphic({data}) {
	const paddings = getPaddingsClassFromData(data)
	const heading = data?.heading || ''
	const image = formatImageCMSData(data?.image?.image || {})
	const buttonData = getButtonLinkData(data?.button ||{})

	return (
		<div className={paddings}>
			<Row>
				<Header
					className='col-desktop-9 col-tablet-4 col-mobile-8 typo-borna typo-borna-103'
					dangerouslySetInnerHTML={getHtmlFromRedactorField(heading)}
				/>
				<div className='col-desktop-3 col-tablet-2 col-mobile-2'/>
				<ImageWrapper className='col-desktop-2 col-tablet-1 col-mobile-4'>
					<StyledImage
						src={image.url}
						alt={image.alt}
						$aspectRatio={image.aspectRatio}
					/>
				</ImageWrapper>
			</Row>
			{!isStringEmpty(buttonData.url) && (
				<Row className='second'>
					<div className='col-desktop-5 col-tablet-8 col-mobile-4'>
						<LinkButton {...buttonData} />
					</div>
				</Row>
			)}
		</div>
	)
}